import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connectToStores } from 'fluxible-addons-react';
import Page from './components/Page';
import Immutable from 'immutable';
import { intlShape } from 'react-intl';
import BuildVersionNotifier from './components/BuildVersionNotifier';
import trackPageView from './utils/trackPageView';
import { NotificationContainer } from 'react-notifications';

// Listen to HtmlHeadStore and pass the document title to the component
@connectToStores([ 'HtmlHeadStore' ], (context) => {
  const HtmlHeadStore = context.getStore('HtmlHeadStore');
  const { title: extendedTitle } = HtmlHeadStore.getExtendedMessages();

  const result = {
    documentTitle: HtmlHeadStore.getTitleMessage(),
    extendedDocumentTitle: extendedTitle,
    isNavigationComplete: HtmlHeadStore.isNavigationComplete()
  };

  return result;
})
class Application extends Component {

  static propTypes = {
    isNavigationComplete: PropTypes.bool.isRequired,
    currentRoute: PropTypes.object,
    currentNavigateError: PropTypes.shape({
      statusCode: PropTypes.number.isRequired,
      message: PropTypes.string.isRequired
    }),
    location: PropTypes.object.isRequired,

    // prop coming from HtmlHeadStore
    documentTitle: PropTypes.object.isRequired,
    extendedDocumentTitle: PropTypes.object,
    children: PropTypes.element

  };

  static contextTypes = {
    intl: intlShape
  };

  componentDidUpdate(prevProps) {
    const { documentTitle, extendedDocumentTitle, currentRoute } = this.props;
    const { intl } = this.context;
    let title = intl.formatMessage(documentTitle);

    if (extendedDocumentTitle) {
      title += ' - ' + intl.formatMessage(extendedDocumentTitle);
    }

    document.title = title;

    if (!Immutable.is(prevProps.currentRoute, currentRoute)) {
      trackPageView(currentRoute.get('url'));
    }
  }

  render() {
    const { isNavigationComplete, location } = this.props;
    const loadingClassName = isNavigationComplete ? '' : 'loading';
    return (
      <div className='flex-element flex-container flex-vertical'>
        <BuildVersionNotifier/>
        <Page footer location={ location } className={ loadingClassName }>
          { this.props.children }
        </Page>
        <NotificationContainer/>
      </div>
    );
  }

}

export default Application;



// WEBPACK FOOTER //
// ./src/Application.js